import { IWebsiteBuilderEditorHistoryActionBase, IWebsiteBuilderHistorySnapshot, WebsiteBuilderEditorActionType } from "../../websiteBuilderEditorAction";
import { IWebsiteBuilderRoot } from "pages/secure/facility/websiteBuilder/editor/nodes/root/websiteBuilderRoot";
import { cloneDeep } from "lodash";
import { IAddNodeAction } from "./addNode";
import { IWebsiteBuilderHeader } from "pages/secure/facility/websiteBuilder/editor/nodes/section/websiteBuilderHeader";
import { IWebsiteBuilderFooter } from "pages/secure/facility/websiteBuilder/editor/nodes/section/websiteBuilderFooter";
import { IWebsiteBuilderNodeLifecycleSnapshot } from "../../actionHelpers/nodeLifecycleSnapshot";
import { IWebsiteBuilderGeneralTraversalNode } from "../../actionHelpers/generalTraversal";

export interface IDeleteNodeActionPayload {
  snapshot: IWebsiteBuilderNodeLifecycleSnapshot;
}

export interface IDeleteNodeAction extends IWebsiteBuilderEditorHistoryActionBase {
  type: typeof WebsiteBuilderEditorActionType.DELETE_NODE;
  payload: IDeleteNodeActionPayload;
}

export function getDeleteNodeInverseAction(action: IDeleteNodeAction): IAddNodeAction {
  const { snapshot } = action.payload;

  return {
    type: WebsiteBuilderEditorActionType.ADD_NODE,
    pageId: action.pageId,
    device: action.device,
    scrollNodeId: snapshot.inverseScrollNodeId,
    payload: {
      snapshot: cloneDeep(snapshot),
    },
  };
}

function deleteNodeTraversal(
  header: IWebsiteBuilderHeader,
  root: IWebsiteBuilderRoot,
  footer: IWebsiteBuilderFooter,
  deleteId: string,
): IWebsiteBuilderHistorySnapshot {
  function traverse(node: IWebsiteBuilderGeneralTraversalNode): IWebsiteBuilderGeneralTraversalNode {
    if (!node.children) {
      return node;
    } else {
      return {
        ...node,
        children: node.children
          .filter(child => child.id !== deleteId)
          .map(traverse),
      };
    }
  }

  return {
    header: traverse(header) as IWebsiteBuilderHeader,
    root: traverse(root) as IWebsiteBuilderRoot,
    footer: traverse(footer) as IWebsiteBuilderFooter,
  };
}

export function applyDeleteNodeChange(
  header: IWebsiteBuilderHeader,
  root: IWebsiteBuilderRoot,
  footer: IWebsiteBuilderFooter,
  action: IDeleteNodeAction,
): IWebsiteBuilderHistorySnapshot {
  const deleteId = action.payload.snapshot.node.id;

  if (
    header.id === deleteId ||
    root.id === deleteId ||
    footer.id === deleteId
  ) {
    return { header, root, footer };
  }

  return deleteNodeTraversal(header, root, footer, deleteId);
}
